<template>
  <div :class="['modal']" v-show="isVisible">
    <div class="component fade-in-up" ref="component">
      <button class="close" @click="closeModal" />
      <component :is="modal.component" />
    </div>
  </div>
</template>

<script>
  import ModalMixin from 'mixins/modal';
  import { mapState } from 'vuex';

  export default {
    name: 'ModalContainer',
    mixins: [ModalMixin],
    data () {
      return { };
    },

    computed: {
      ...mapState(['modal']),

      isVisible () {
        return this.modal.visible;
      }
    },

    mounted () {
      this.bindEventListeners();
      this.$refs.component.classList.add('is-active');
    },

    destroyed () {
      this.removeEventListeners();
    },

    methods: {
      bindEventListeners () {
        document.body.addEventListener('keyup', this.closeModal);
      },

      removeEventListeners () {
        document.body.removeEventListener('keyup', this.closeModal);
      },

      closeModal (e) {
        if ((e && e.keyCode && e.keyCode !== 27)) {
          return true;
        }

        this.$store.dispatch('modal/closeModal');
      }
    }
  };

</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/helpers'
  @require '~global/breakpoints'

  .modal
    @extend .flex-vh
    background: rgba(0,0,0,.3)
    height: 100%
    width: 100%
    position: fixed
    z-index: 99

  .close
    @extend .flex-vh
    background: $white url('~icons/close.svg?bg') center no-repeat
    background-size: 14px
    line-height: 0
    border-radius: 50%
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2)
    width: 60px;
    height: 60px;
    position: absolute
    top: 0
    right: 10px
    border: 0
    transform: translate(0%, -50%)
    z-index: 2

  .close:hover
    cursor: pointer

  .component
    animation-duration: .4s
    width: 100%
    max-width: 420px
    background: $white
    border-radius: 15px
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2)
    padding: 40px
    position: relative

  @media (max-width: $mobile)
    .component
      max-width: 100%
      border-radius: 15px 15px 0 0
      margin-top: auto

</style>
